import { useState, useEffect, useCallback } from 'react';
import useFetch from 'use-http';

import { API_ROUTES } from '../../constants';

import { TAPIResponseApplicationAttributeTypes } from './application-types.types';
import { TApplicationAttribute } from '../application-attributes.types';

export const useAPIFetchApplicationTypes =
  (): TAPIResponseApplicationAttributeTypes => {
    const { get, response, loading, error } = useFetch(API_ROUTES.ATTRIBUTES);

    const [applicationTypes, setApplicationTypes] = useState<
      TApplicationAttribute[] | []
    >([]);

    const fetchApplicationTypes = useCallback(async (): Promise<void> => {
      const {data} = await get('/apptype');

      setApplicationTypes(data ? data.items : []);
    }, [get]);

    useEffect(() => {
      fetchApplicationTypes();
      // eslint-disable-next-line
    }, []);

    return {
      data: applicationTypes,
      loading,
      loaded: response.ok,
      error,
      fetchApplicationTypes,
    };
  };
